<template>
  <div class="py-6">
    <h1 class="heading text-4xl">Well Done!</h1>
    <div v-if="error === 1" class="bg-blue-400 m-4 p-6">
      <h3 class="font-semibold font-main text-3xl text-white pb-4">
        Uploading Result
      </h3>
      <p class="text-main text-white">
        Please Wait
      </p>
    </div>
    <div v-if="error >= 2" class="bg-red-500 m-4 p-6">
      <h3 class="font-semibold font-main text-3xl text-white pb-4">
        Error: Problem Saving Result
      </h3>
      <p class="text-main text-white">
        Please Note Your Score/ Time and Email it to:
        lockdownorienteering@gmail.com
      </p>
    </div>
    <h3 class="font-semibold font-main text-2xl mt-3">Score: {{ score }}</h3>
    <h3 class="font-semibold font-main text-2xl mb-3">
      Time: {{ time / 1000 }}s
    </h3>
    <router-link
      v-if="$route.path.includes('lockdown')"
      class="button blue mx-2 mt-4"
      to="/lockdown"
      >Return Home</router-link
    >
    <router-link
      v-if="$route.path.includes('sejs')"
      class="button blue mx-2 mt-4"
      to="/sejs"
      >Return Home</router-link
    >
    <router-link
      v-if="$route.path.includes('teams')"
      class="button blue mx-2 mt-4"
      to="/teams"
      >Return Home</router-link
    >
    <router-link v-else class="button blue mx-2 mt-4" to="/"
      >Return Home</router-link
    >
    <a
      v-if="$route.path.includes('teams')"
      href="http://maprunner.co.uk/lockdown-results/"
      class="button red mx-2"
      >View Results</a
    >
  </div>
</template>
<script>
export default {
  props: {
    score: {
      type: String,
      default: '',
    },
    time: {
      type: Number,
      default: 0,
    },
    error: {
      type: Number,
      default: 0,
    },
  },
}
</script>
